module.exports = __webpack_public_path__ + "img/product1.4164248e.jpg";